import ButtonBigWithAction from 'elements/ButtonBigWithAction';
import Create from './Create';
import Table from './Table';
import {useState,useEffect} from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import {DebounceInput} from 'react-debounce-input';
import GetRequest from 'components/GetRequest';
import Edit from './Edit';
import Delete from './Delete';

const SavedItems = () => {
    const [isOpenCreate, setIsOpenCreate] = useState(false)
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [itemForEdit, setItemForEdit] = useState(null)
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [itemForDelete, setItemForDelete] = useState(null)
    const [items, setItems] = useState(null)
    const [pagination, setPagination] = useState(null)
    const [pageMeta, setPageMeta] = useState(null)
    const [updatedItems, setUpdatedItems] = useState(false)
    const [pending, setPending] = useState(false)
    const [exSearch, setExSearch] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams()
    let { search } = useLocation();

    useEffect(() => {
        setPending(true)
        var page = searchParams.get("page")
        var searchPa = searchParams.get("search") || ''
        if(searchPa != null && exSearch != searchPa) {
            page = "1"
            setSearchParams({page: 1, search: searchPa})
        }
        GetRequest('api/savedItems?page='+page+'&search='+searchPa)
        .then((response) => {
            setItems(response.data.data)
            setPagination(response.data.links)
            setPageMeta({total: response.data.total, from: response.data.from, to: response.data.to, currentPage: response.data.current_page})
            setExSearch(searchPa)
            setPending(false)
        })
        .catch(error => {
            setItems(error.response.data)
            setPending(false)
        })
    }, [updatedItems, search])

    const handleClick = (e) => {
        setIsOpenCreate(!isOpenCreate)
    } 
    
    const actions = (
        <>
            <ButtonBigWithAction type="submit" addClass="text-white bg-emerald-500" title="Gönder" />
        </>
    )

    return (
        <div className='text-center mx-6 mb-6 mt-3'>
            
            <div className='py-2 border-b-2 border-gray-400 flex items-center justify-between'>
                <p className='text-gray-800 text-xl'>Kayıtlı Ürün/Hizmet Kalemleri</p>
                <div className='flex justify-end gap-x-4'>
                    <ButtonBigWithAction type="button" onClick={handleClick} addClass="text-white bg-sky-700" title="Yeni Ürün/Hizmet Ekle" />
                </div>                  
            </div>  
            <div className='mt-4'>
                <div className='w-full flex justify-start mb-2'>
                <DebounceInput
                    minLength={4}
                    debounceTimeout={500}
                    onChange={event =>setSearchParams({page: searchParams.get("page"),search: event.target.value})} 
                    className="form-input w-full lg:max-w-[250px] rounded px-2 py-1 text-sm"
                    placeholder="İsim İçerisinde Ara"
                    value={searchParams.get("search")} />

                </div>
                <Table data={items} 
                    actions={
                        {edit: {status: isOpenEdit, action: setIsOpenEdit}, 
                        editted: {status: itemForEdit, action: setItemForEdit},
                        delete: {status: isOpenDelete, action: setIsOpenDelete},
                        deleted: {status: itemForDelete, action: setItemForDelete},}
                    } 
                    progressPending={pending}
                    pagination={pagination}
                    pageMeta={pageMeta}
                /> 
            </div>
            <Create isOpen={isOpenCreate} isOpenAction={setIsOpenCreate} updateStatus={updatedItems} updatedAction={setUpdatedItems} />
            <Edit isOpen={isOpenEdit} isOpenAction={setIsOpenEdit} updateStatus={updatedItems} updatedAction={setUpdatedItems} selectedData={itemForEdit}/>
            <Delete isOpen={isOpenDelete} isOpenAction={setIsOpenDelete} updateStatus={updatedItems} updatedAction={setUpdatedItems} selectedData={itemForDelete}/>
            
            
        </div>
    )
};

export default SavedItems;
